import React, { useState } from "react";
// import { Link } from 'react-router-dom';
// import logo1 from '../StrongImages/Logo1.png'; // Import your logo file
import Navbar from "../StrongComponents/Navbar";
import Ade1 from "../StrongImages/CanvasImages/Ade1.jpeg";
import Ade2 from "../StrongImages/CanvasImages/Ade2.jpeg";
import Ade3 from "../StrongImages/CanvasImages/Ade3.jpeg";
import Ade4 from "../StrongImages/CanvasImages/Ade4.jpeg";
import Ade5 from "../StrongImages/CanvasImages/Ade5.jpeg";
import Lona1 from "../StrongImages/CanvasImages/Lona1.jpeg";
// import Sticker4 from '../StrongImages/StickerImages/Sticker4.png';
// import Sticker3 from '../StrongImages/StickerImages/Sticker3.png';
import SliderComponent from "../StrongComponents/SliderComponent";
import SliderImage1 from "../StrongImages/SliderImages/SliderImage1.jpeg";
import SliderImage2 from "../StrongImages/SliderImages/SliderImage2.jpeg";
import SliderImage3 from "../StrongImages/SliderImages/SliderImage3.jpeg";
import SliderImage4 from "../StrongImages/SliderImages/SliderImage4.jpeg";
import SliderImage5 from "../StrongImages/SliderImages/SliderImage5.jpeg";
import SliderImage6 from "../StrongImages/SliderImages/SliderImage6.jpeg";
import SliderImage7 from "../StrongImages/SliderImages/SliderImage7.jpeg";
import SliderImage8 from "../StrongImages/SliderImages/SliderImage8.jpeg";
import Footer from "../StrongComponents/Footer";
import { Helmet } from "react-helmet";
import a1 from "../StrongImages/Backgroundwall.jpeg";

const ProductCard = ({ id, image, title, price, category, showCalculate }) => {
  const [dimensions, setDimensions] = useState({ width: "", height: "" });
  const [totalPrice, setTotalPrice] = useState(0);

  const calculatePrice = () => {
    const squareMeters = (dimensions.width * dimensions.height).toFixed(2);
    const total = (squareMeters * price).toFixed(2);
    setTotalPrice(total);
  };

  const handleOrder = () => {
    calculatePrice(); // Ensure the price is calculated

    const squareMeters = (dimensions.width * dimensions.height).toFixed(2);
    const total = (squareMeters * price).toFixed(2);
    setTotalPrice(total);

    console.log("Placing order:", {
      productId: id,
      productName: title,
      category: category,
      price: price,
      dimensions: `${dimensions.width}m x ${dimensions.height}m = ${squareMeters}m²`,
      totalPrice: `${showCalculate ? total : price} BRL`,
      orderId: Math.floor(Math.random() * 1000) + 1, // Generate a random order ID
    });

    const message = `Olá, gostaria de fazer o seguinte pedido:\n\nProduto: ${title}\nPreço: R$${price},00${
      showCalculate
        ? `\nDimensões: ${dimensions.width}m x ${dimensions.height}m\nPreço Total: R$${total}`
        : ""
    }`;

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);

    // Provide the phone number of the WhatsApp profile you want to send the message to
    const phoneNumber = "+5513978168583"; // Replace this with the phone number of the WhatsApp profile

    // Construct the WhatsApp URL with the pre-filled message and phone number
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open WhatsApp with the pre-filled message and phone number
    window.open(whatsappLink, "_blank");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDimensions((prevDimensions) => ({
      ...prevDimensions,
      [name]: parseFloat(value) || "", // Convert value to float or empty string
    }));
  };

  return (
    <div className="product p-8 bg-gray-300 border rounded-lg text-black dark:text-white dark:bg-slate-700 shadow-xl">
      <img src={image} alt={title} className="mx-auto mb-4" />
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      {showCalculate && <p className="text-lg">R${price},00</p>}
      {showCalculate && (
        <div className="flex items-center dark:text-black justify-center mb-4">
          <input
            type="number"
            name="width"
            value={dimensions.width}
            onChange={handleInputChange}
            className="w-20 mr-2 p-2 border border-gray-400 rounded"
            placeholder="Largura (m)"
          />
          <span className="dark:text-white">x</span>
          <input
            type="number"
            name="height"
            value={dimensions.height}
            onChange={handleInputChange}
            className="w-20 ml-2 p-2 border border-gray-400 rounded"
            placeholder="Altura (m)"
          />
        </div>
      )}

      {totalPrice > 0 && (
        <p className="text-lg dark:text-white p-2">
          Valor Total: R${totalPrice}
        </p>
      )}
      <div className="">
        {showCalculate && (
          <div className="">
            <button
              onClick={calculatePrice}
              className="bg-gray-600 text-white font-bold py-2 px-6 rounded-full hover:bg-gray-500"
            >
              Calcular
            </button>
          </div>
        )}
        <div className="flex justify-center items-center p-2">
          <button
            onClick={handleOrder}
            className="bg-blue-900 text-white font-bold py-2 px-6 rounded-full hover:bg-blue-800"
          >
            Comprar
          </button>
        </div>
      </div>
    </div>
  );
};

const TestimonialCard = ({ name, message }) => (
  <div className="testimonial bg-white dark:bg-gray-600 p-8 border rounded-lg shadow">
    <p className="text-lg mb-4">{message}</p>
    <p className="">- {name}</p>
  </div>
);

const HomePage = () => {
  const images = [
    SliderImage1,
    SliderImage2,
    SliderImage3,
    SliderImage4,
    SliderImage5,
    SliderImage6,
  ];

  return (
    <div className="bg-gray-100 dark:bg-black text-black dark:text-white">
      <Helmet>
        <title>Premium Printing Services - IGF PRINTS</title>
        <meta
          name="description"
          content="Discover top-quality printing solutions for stickers, canvas, advertisements, and more at IGF PRINTS. Your one-stop shop for all your printing needs."
        />
        <meta
          name="keywords"
          content="Canvas Print,Comunicação visual em Peruíbe,Impressão de lona em Peruíbe,Impressão de adesivo em Peruíbe,Marketing materials printing,Custom marketing collateral,Branded merchandise printing,Custom promotional products,
Advertising printing services,Marketing flyer printing,Custom direct mail printing,Trade show display printing,Custom catalog printing,Personalized marketing materials,Custom marketing brochures,Point of sale printing,Event marketing printing,Custom marketing posters,Retail signage printing,Custom marketing banners,Promotional postcard printing,Custom marketing decals,Custom presentation folders,Custom gift card printing,Marketing booklet printing,Custom event invitations,Custom coupon printing,Branded apparel printing,Marketing sign printing,Custom promotional labels,Custom marketing stickers,Corporate printing services,Custom table tent printing,Custom promotional flags,Marketing display printing,Custom sales sheets,Custom door hanger marketing,Custom marketing magnets,Personalized marketing gifts,Custom trade show materials,Custom marketing swag,Custom marketing packages,Custom event signage,Custom banner stands,Custom marketing folders,Branded marketing materials,Custom marketing kits,Custom promotional banners,Personalized event printing,Custom marketing giveaways,Custom branded products,High-quality marketing print,Custom marketing mailers,Personalized marketing solutions,advertisement printing,print solutions,IGF PRINTS,igf print,igf prints,Igf Prints, Igf print,Impressão digital em Peruíbe,Impressão de lona e adesivos,Envelopamento em Peruíbe, Custom printing services,Sticker printing services,Label printing services,Custom sticker design,Business card printing,Custom banner printing,Flyer printing services,Custom brochure printing,Personalized stickers,Custom decal printing,Vinyl sticker printing,Promotional item printing,Custom signage printing,Logo sticker printing,High-quality printing,Digital printing services,Offset printing services,Custom poster printing,Custom photo printing,Custom T-shirt printing,Custom canvas printing,Personalized stationery,Custom envelope printing,Wedding invitation printing,Custom greeting cards,Custom packaging printing,Roll label printing,Die-cut sticker printing,Custom wall decals,Custom vehicle decals,Custom window stickers,Personalized wall art,Custom menu printing,Custom notebook printing,Custom calendar printing,Event ticket printing,Custom ID badges,Custom wristbands,Certificate printing,Book printing services,Postcard printing,Custom coasters,Custom magnets,Door hanger printing,Custom keychains,Promotional magnets,Personalized gifts,Trade show materials,Marketing material printing"
        />
      </Helmet>

      {/* Navigation bar */}
      <Navbar />

      {/* Slider Section */}
      <section>
        <SliderComponent images={images} />
      </section>

      {/* <section>
    <div className='p-5 text-wrap text-center shadow-md bg-slate-300 dark:text-black rounded-md m-5 flex justify-center items-center text-sm font-bold'>
        <p>
        Valor da promoção para compras no Pix, só entrará na fila de impressão após enviar o comprovante pelo whatsapp junto com a arte a ser impressa em PDF
        </p>
    </div>
</section> */}

      {/* Hero Section */}
      <section className="py-6">
        <div className="container mx-auto px-4 text-center">
          <button className="bg-green-600 dark:bg-white border text-white dark:text-green-600 font-bold py-2 px-6 rounded-full hover:bg-green-500 dark:hover:bg-green-600 dark:hover:text-white">
            <a
              href="https://wa.me/message/XWHE7MEZFPWBJ1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Compra via Whatsapp
            </a>
          </button>
        </div>
      </section>

      {/* Product Categories Section */}
      <section
        className="py-2  bg-cover bg-center"
        style={{ backgroundImage: `url(${a1})` }}
      >
        <div className="container mx-auto px-4 text-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
            <ProductCard
              id="1"
              image={SliderImage7}
              title="Banner"
              price="80"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="2"
              image={SliderImage8}
              title="Lona P/ Luminoso"
              price="80"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="3"
              image={Ade1}
              title="Adesivo alta colagem"
              price="70"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="4"
              image={Lona1}
              title="ADESIVO Promocional"
              price="60"
              category="Canvas"
              showCalculate={true}
            />
            <ProductCard
              id="5"
              image={Ade2}
              title="Adesivo Perfurado"
              price="90"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="6"
              image={Ade3}
              title="Adesivo Transparente"
              price="60"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="7"
              image={Ade4}
              title="Lona com ilhós"
              price="90"
              category="Stickers"
              showCalculate={true}
            />
            <ProductCard
              id="8"
              image={Ade5}
              title="Lona "
              price="60"
              category="Stickers"
              showCalculate={true}
            />
          </div>
        </div>
      </section>

      <section>
        <div className="p-1 ">
          <img className=" rounded-lg" src={SliderImage6} alt="image" />
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-white text-black dark:bg-black dark:text-white border m-2 rounded-md">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-8">
            Clientes satisfeitos
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
            <TestimonialCard
              name="Jucelino Andrade"
              message="Produtos de ótima qualidade e excelente atendimento ao cliente!"
            />
            <TestimonialCard
              name="Maria Cristina"
              message="Adoro a variedade de designs disponíveis. Definitivamente pedirei novamente!"
            />
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default HomePage;
